// extracted by css-extract-rspack-plugin
export default {"cls1":"StatelessWorkCardsUpsellModal-styles-cls1_-Nu","cls2":"StatelessWorkCardsUpsellModal-styles-cls2_mku StatelessWorkCardsUpsellModal-styles-cls1_-Nu"};